<template>
    <div>
        <table class="table">
            <tr v-for="inspection in filteredInspections">
                <td style="width: 50px;">
                    <span 
                        class="material-icons" 
                        v-html="inspectionIcon(inspection)" 
                        :style="inspectionIconStyles(inspection)"
                    ></span>
                </td>
                <td>
                    <a href="#" @click.prevent="showInspection(inspection)">{{ inspection.definition.name }}</a>
                    <span v-if="!inspection.completed_at" style="color: #999; display: block;">Incomplete</span>
                    <span v-else style="color: #999; display: block;">Completed {{ inspection.completed_at | formatDate('DD/MM/YY') }}</span>
                </td>
                <td style="width: 50px;">
                    <avatar :user="inspection.completed_by" v-if="inspection.completed_at"></avatar>
                </td>
                <td class="text-right" style="width: 100px;"><ui-button size="small" @click.prevent="showInspection(inspection)">View</ui-button></td>
            </tr>
        </table>
        <inspection-modal 
            ref="inspectionModal" 
            @saved="$emit('updated')" 
            @reset="$emit('updated')" 
            @tasks-updated="$emit('tasks-updated')" 
        />
    </div>
</template>

<script>
    import InspectionModal from '../../inspections/InspectionModal'
    import Filters from '../../../filters'

    export default {
        filters: Filters,
        components: { InspectionModal },
        props: {
            inspections: { required: true },
            hideHealthChecks: { type: Boolean, default: false }
        },
        computed: {
            filteredInspections() {
                if (this.hideHealthChecks) {
                    return this.inspections.filter(inspection => {
                        return !inspection.booking_id
                    })
                }

                return this.inspections
            }
        },
        methods: {
            showInspection(inspection) {
                this.$refs.inspectionModal.open(inspection.id)
            },
            inspectionIcon(inspection) {
                if (inspection.completed_at) {
                    return 'check_circle'
                }

                return 'warning'
            },
            inspectionIconStyles(inspection) {
                if (inspection.completed_at) {
                    return 'vertical-align: middle; color: green;'
                }

                return 'vertical-align: middle; color: gold;'
            }
        }
    }
</script>